import { render, staticRenderFns } from "./importarNota.vue?vue&type=template&id=1d982206"
import script from "./importarNota.vue?vue&type=script&lang=js"
export * from "./importarNota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports